import { Component, inject, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { Logout } from '../../actions/auth-actions';

@Component({
  selector: 'app-logout-success',
  templateUrl: './logout-success.component.html'
})
export class LogoutSuccessComponent implements OnInit {
  private readonly store = inject(Store);

  public ngOnInit(): void {
    this.store.dispatch(new Logout());
  }
}
